import { render, staticRenderFns } from "./rewards.vue?vue&type=template&id=0c55e0fc&scoped=true"
import script from "./rewards.vue?vue&type=script&lang=js"
export * from "./rewards.vue?vue&type=script&lang=js"
import style0 from "./rewards.vue?vue&type=style&index=0&id=0c55e0fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55e0fc",
  null
  
)

export default component.exports